import { WidgetProps } from '@rjsf/utils';
import { Grid, TextField } from '@mui/material';
import { useEffect, useState } from 'react';

const HEX_RE = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

function normalise(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return '';
  return trimmed.startsWith('#') ? trimmed : '#' + trimmed;
}

export function DynamicFormColourInput(props: WidgetProps) {
  const { value, onChange, readonly, label, placeholder } = props;
  const [inputValue, setInputValue] = useState<string>(value ?? '');

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  const handleBlur = () => {
    const hex = normalise(inputValue);
    if (!hex) {
      onChange(undefined);
      setInputValue('');
    } else if (HEX_RE.test(hex)) {
      onChange(hex);
      setInputValue(hex);
    } else {
      // Revert to last valid stored value
      setInputValue(value ?? '');
    }
  };

  const isValid = HEX_RE.test(normalise(inputValue));

  return (
    <Grid
      container
      spacing={1}
      wrap="nowrap"
      sx={{
        alignItems: 'center'
      }}
    >
      <Grid size="grow">
        <TextField
          label={label}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleBlur}
          disabled={readonly}
          placeholder={placeholder ?? '#000000'}
          fullWidth
          size="small"
          variant="outlined"
          slotProps={{
            htmlInput: { maxLength: 7 }
          }}
        />
      </Grid>
      <Grid>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 4,
            backgroundColor: isValid ? normalise(inputValue) : 'transparent',
            border: '1px solid rgba(0,0,0,0.23)',
            flexShrink: 0
          }}
        />
      </Grid>
    </Grid>
  );
}
